module.exports = new __parcel__URL__("nevermind.6c3fa173.jpg").toString();